/*
 * CAI: switch between sub-collections without a full page load.
 *
 * WHY: tapping FLATS / HEELS / ALL SEASON / PLATFORM WEDGES in the category bar
 * reloaded the whole page (operator, 24 Sep 2026 live review T7); Oath and Uni
 * Seoul already swap in place. This fetches the target collection page, replaces
 * the sections it shares with the current page (title, product grid with its
 * filters and size bar) and pushStates the URL. Horizon's web components re-init
 * on insertion; inline scripts inside swapped sections are re-run.
 *
 * Progressive enhancement: the tiles are real <a href> links. A modified click,
 * a cross-origin or non-collection link, a target whose sections differ from this
 * page (another template), or any failure falls back to normal navigation.
 */
(function () {
  if (window.__caiCollectionSwitchBound) return;
  window.__caiCollectionSwitchBound = true;

  var busy = false;
  // Page fetches started early, keyed by URL. A finger touching a tile (or a
  // mouse resting on one) starts the fetch, so by the time the tap lands most
  // of the ~1 s Shopify spends rendering the collection has already passed.
  var early = {};

  function prefetch(url) {
    if (!early[url]) {
      early[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      });
      early[url].catch(function () { delete early[url]; });
      setTimeout(function () { delete early[url]; }, 60000); // never serve a stale grid
    }
    return early[url];
  }

  function sectionsIn(root) {
    return Array.prototype.slice.call(
      root.querySelectorAll('main .shopify-section[id^="shopify-section-"], #MainContent .shopify-section[id^="shopify-section-"]')
    );
  }

  function rerunScripts(node) {
    node.querySelectorAll('script').forEach(function (old) {
      if (old.type && old.type !== 'text/javascript' && old.type !== 'module') return;
      var s = document.createElement('script');
      for (var i = 0; i < old.attributes.length; i++) s.setAttribute(old.attributes[i].name, old.attributes[i].value);
      if (!old.src) s.textContent = old.textContent;
      old.replaceWith(s);
    });
  }

  function markActive(href) {
    var path = new URL(href, location.origin).pathname;
    document.querySelectorAll('.category-card').forEach(function (card) {
      var p = new URL(card.getAttribute('href') || '', location.origin).pathname;
      card.classList.toggle('category-card--active', p === path);
    });
  }

  async function swapTo(url, push) {
    if (busy) return false;
    busy = true;
    var main = document.querySelector('#MainContent') || document.querySelector('main');
    if (main) main.setAttribute('aria-busy', 'true');
    try {
      var html = await prefetch(url);
      delete early[url];
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var current = sectionsIn(document);
      var incoming = {};
      sectionsIn(doc).forEach(function (s) { incoming[s.id] = s; });
      // Same template on both sides, or do a real navigation.
      if (!current.length || current.some(function (s) { return !incoming[s.id]; })) throw new Error('template differs');
      // The address must move BEFORE the grid is swapped in. Horizon's paginated-list
      // builds its next-page URL from window.location the moment it connects, so with
      // the old address it fetched page 2 of the collection the shopper came FROM and
      // appended it under the new one (8 Oct 2026: flats under Heels after a tap from
      // the flats page; a direct visit was clean). A failure after this point still
      // falls back to a full load of the same URL.
      if (push) history.pushState({ caiCollectionSwitch: true }, '', url);
      current.forEach(function (s) {
        if (s.querySelector('.category-icons-section')) return; // keep the bar and its slider in place
        var fresh = document.importNode(incoming[s.id], true);
        s.replaceWith(fresh);
        rerunScripts(fresh);
      });
      if (doc.title) document.title = doc.title;
      markActive(url);
      return true;
    } catch (e) {
      return false;
    } finally {
      if (main) main.removeAttribute('aria-busy');
      busy = false;
    }
  }

  function targetUrl(card) {
    var url;
    try { url = new URL(card.getAttribute('href'), location.origin); } catch (e) { return null; }
    if (url.origin !== location.origin || url.pathname.indexOf('/collections/') !== 0) return null;
    // Keep the draft-theme preview when there is one.
    var here = new URL(location.href);
    ['preview_theme_id'].forEach(function (k) {
      if (here.searchParams.get(k) && !url.searchParams.get(k)) url.searchParams.set(k, here.searchParams.get(k));
    });
    return url;
  }

  // Category tiles, and the quick-filter chips (sections/main-collection.liquid, data-cai-swap).
  var SWAP = 'a.category-card, a[data-cai-swap]';

  function warm(event) {
    var card = event.target.closest && event.target.closest(SWAP);
    if (!card || card.classList.contains('category-card--active')) return;
    var url = targetUrl(card);
    if (url) prefetch(url.toString());
  }
  document.addEventListener('touchstart', warm, { passive: true });
  document.addEventListener('pointerdown', warm);
  document.addEventListener('mouseover', warm);

  document.addEventListener('click', async function (event) {
    var card = event.target.closest && event.target.closest(SWAP);
    if (!card) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    var url = targetUrl(card);
    if (!url) return;
    event.preventDefault();
    if (card.classList.contains('category-card--active')) return;
    var ok = await swapTo(url.toString(), true);
    if (!ok) location.href = url.toString();
  });

  window.addEventListener('popstate', async function () {
    if (!document.querySelector('.category-icons-section')) return;
    var ok = await swapTo(location.href, false);
    if (!ok) location.reload();
  });
})();
